import styled from 'styled-components'

export const DataPreview = styled.div`
  border-top: 1px solid var(--color-border);
  overflow: hidden;
  line-height: 2.5;
  text-overflow: ellipsis;
`
